/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: ba-ui-common (C) Copyright IBM Corp. 2019, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

import PropTypes from 'prop-types';

import React, { Component } from 'react';
import { FlexLayout, FlexItem, Radio } from '@waca/ca-ui-toolkit';

import stringResource from 'ba-filter-nls';
import { getTid } from 'utils/tid';
import { FILTER_TYPE } from './filterProps';

export default class FilterTypeSelector extends Component<any, any> {
	// Define properties and types
	static propTypes = {
		onChange: PropTypes.func.isRequired,
		type: PropTypes.oneOf([FILTER_TYPE.SELECT_VALUE, FILTER_TYPE.RANGE]).isRequired,
		readOnly: PropTypes.bool,
	};

	// Define default property values
	static defaultProps = {
		onChange: null,
		type: FILTER_TYPE.RANGE,
		readOnly: false,
	};

	render() {
		const { type, onChange, readOnly } = this.props;

		return (
			<FlexLayout direction="row">
				<FlexItem grow={1}>
					<Radio
						name="filterType"
						direction="horizontal"
						align="left"
						label={stringResource.get('upperRange')}
						value="range"
						checked={type === FILTER_TYPE.RANGE}
						onChange={onChange}
						readOnly={readOnly}
						data-tid={getTid('filterTypeSelector', 'filterTypeRange')}
					/>
				</FlexItem>
				<FlexItem>
					<Radio
						name="filterType"
						direction="horizontal"
						align="left"
						label={stringResource.get('individualItems')}
						value="selectValue"
						checked={type === FILTER_TYPE.SELECT_VALUE}
						onChange={onChange}
						readOnly={readOnly}
						data-tid={getTid('filterTypeSelector', 'filterTypeSelectValue')}
					/>
				</FlexItem>
			</FlexLayout>
		);
	}
}
